/**
 * TypeScript utility for Office.js Outlook API
 * Provides type guards and interfaces for compose/read mode detection
 */
/**
 * Type guard to check if item is in compose mode
 * In compose mode, subject is an object with getAsync/setAsync methods
 * In read mode, subject is a string value
 */
export function isComposeMode(item) {
    return item && typeof item.subject === 'object' && typeof item.subject.getAsync === 'function';
}
/**
 * Type guard to check if item is in read mode
 * In read mode, subject is a string value
 * In compose mode, subject is an object
 */
export function isReadMode(item) {
    return item && typeof item.subject === 'string';
}
